import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@bindery/ui/components/ui/card";
import type { LucideIcon } from "lucide-react";

interface StatCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: LucideIcon;
  iconColor?: string;
  trend?: "up" | "down" | "neutral";
  trendValue?: string;
}

export function StatCard({
  title,
  value,
  subtitle,
  icon: Icon,
  iconColor = "text-skyfall-600",
  trend,
  trendValue,
}: StatCardProps) {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">{title}</CardTitle>
        {Icon && <Icon className={`h-4 w-4 ${iconColor}`} />}
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{value}</div>
        {subtitle && (
          <p className="text-muted-foreground text-xs">{subtitle}</p>
        )}
        {trend && trendValue && (
          <p
            className={`text-xs ${
              trend === "up"
                ? "text-mintleaf-600"
                : trend === "down"
                  ? "text-flamenco-600"
                  : "text-muted-foreground"
            }`}
          >
            {trendValue}
          </p>
        )}
      </CardContent>
    </Card>
  );
}
